module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.name,
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "bsModalLabel",
      "data-toggle": "modal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "bsModalLabel"
    }
  }, [_vm._v(_vm._s(_vm.$t('tasklist')[[_vm.userType - 3]]) + " -> " + _vm._s(_vm.$t('name')) + ":" + _vm._s(_vm.patientInfo.name) + " ,  " + _vm._s(_vm.$t('age')) + " : " + _vm._s(new Date().getFullYear() - _vm.patientInfo.yob) + "  " + _vm._s(_vm.$t('years')))])]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "modal-body center",
    staticStyle: {
      "min-height": "450px"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin fa-5x text-primary",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "input-group",
    staticStyle: {
      "width": "100%",
      "paddingBottom": "15px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.contactNumber),
      expression: "search.contactNumber"
    }],
    staticClass: "input-group-text ",
    attrs: {
      "type": "text",
      "placeholder": ("" + (_vm.$t('contactNumber_name')))
    },
    domProps: {
      "value": (_vm.search.contactNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "contactNumber", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.locationName),
      expression: "search.locationName"
    }],
    staticClass: "input-group-text ",
    attrs: {
      "type": "text",
      "placeholder": ("" + (_vm.$t('location')))
    },
    domProps: {
      "value": (_vm.search.locationName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.search, "locationName", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.search.userType == 3) ? _c('span', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.userOptionsConsultant),
      expression: "search.userOptionsConsultant"
    }],
    staticClass: "input-group-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.search, "userOptionsConsultant", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('ConsultantLbl')))]), _vm._v(" "), _vm._l((_vm.$t('userOptionsConsultant')), function(w, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v("\n                           " + _vm._s(w) + "\n                          ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.search.userType == 4) ? _c('span', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.userOptionsAmbulance),
      expression: "search.userOptionsAmbulance"
    }],
    staticClass: "input-group-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.search, "userOptionsAmbulance", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('AmbulanceLbl')))]), _vm._v(" "), _vm._l((_vm.$t('userOptionsAmbulance')), function(w, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v("\n                           " + _vm._s(w) + "\n                          ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.search.userType == 5) ? _c('span', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.userOptionsDelivery),
      expression: "search.userOptionsDelivery"
    }],
    staticClass: "input-group-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.search, "userOptionsDelivery", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('DeliveryLbl')))]), _vm._v(" "), _vm._l((_vm.$t('userOptionsDelivery')), function(w, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v("\n                           " + _vm._s(w) + "\n                          ")])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success padding5",
    on: {
      "click": function($event) {
        return _vm.searchClick($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('search')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-success padding5",
    on: {
      "click": function($event) {
        return _vm.clearClick($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('clear')))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "scrollbar scrollbar-black bordered-black square",
    staticStyle: {
      "max-height": "250px",
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('name')) + " ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('contactNumber')) + " ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('optionsLbl')) + " ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('cases')) + " ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('action')) + " ")])]), _vm._v(" "), _vm._l((_vm.forwards), function(usr) {
    return _c('tr', {
      key: usr.id
    }, [_c('td', [_vm._v(_vm._s(usr.name) + "/" + _vm._s(usr.locationName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(usr.contactNumber))]), _vm._v(" "), _c('td', [(_vm.search.userType == 3) ? _c('span', _vm._l((_vm.$t('userOptionsConsultant')), function(w, i) {
      return _c('i', {
        key: i
      }, [_vm._v("\n                                    " + _vm._s(usr.userOptionsConsultant.indexOf(i) >= 0 ? w : '') + "\n                            ")])
    }), 0) : _vm._e(), _vm._v(" "), (_vm.search.userType == 4) ? _c('span', _vm._l((_vm.$t('userOptionsAmbulance')), function(w, i) {
      return _c('i', {
        key: i
      }, [_vm._v("\n                              " + _vm._s(usr.userOptionsAmbulance.indexOf(i) >= 0 ? w : '') + "\n                      ")])
    }), 0) : _vm._e(), _vm._v(" "), (_vm.search.userType == 5) ? _c('span', _vm._l((_vm.$t('userOptionsDelivery')), function(w, i) {
      return _c('i', {
        key: i
      }, [_vm._v("\n                              " + _vm._s(usr.userOptionsDelivery.indexOf(i) >= 0 ? w : '') + "\n                      ")])
    }), 0) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(usr.activeCases))]), _vm._v(" "), _c('td', [_c('input', {
      attrs: {
        "type": "radio",
        "name": "fuser"
      },
      domProps: {
        "value": usr.id
      },
      on: {
        "change": function($event) {
          return _vm.selectThis(usr)
        }
      }
    })])])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('warning')))]), _vm._v(" "), (_vm.search.userType == 3) ? _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.$t('consultantTasks')), function(s, i) {
    return _c('li', {
      key: i,
      staticClass: "list-group-item"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.taskForward.taskType),
        expression: "taskForward.taskType"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": i,
        "checked": Array.isArray(_vm.taskForward.taskType) ? _vm._i(_vm.taskForward.taskType, i) > -1 : (_vm.taskForward.taskType)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.taskForward.taskType,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = i,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.taskForward, "taskType", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.taskForward, "taskType", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.taskForward, "taskType", $$c)
          }
        }
      }
    }), _vm._v("\n                            " + _vm._s(s) + "\n                            ")])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.search.userType == 4) ? _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.$t('ambulanceTasks')), function(s, i) {
    return _c('li', {
      key: i,
      staticClass: "list-group-item"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.taskForward.taskType),
        expression: "taskForward.taskType"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": i,
        "checked": Array.isArray(_vm.taskForward.taskType) ? _vm._i(_vm.taskForward.taskType, i) > -1 : (_vm.taskForward.taskType)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.taskForward.taskType,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = i,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.taskForward, "taskType", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.taskForward, "taskType", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.taskForward, "taskType", $$c)
          }
        }
      }
    }), _vm._v("\n                            " + _vm._s(s) + "\n                            ")])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.search.userType == 5) ? _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.$t('deliveryTasks')), function(s, i) {
    return _c('li', {
      key: i,
      staticClass: "list-group-item"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.taskForward.taskType),
        expression: "taskForward.taskType"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": i,
        "checked": Array.isArray(_vm.taskForward.taskType) ? _vm._i(_vm.taskForward.taskType, i) > -1 : (_vm.taskForward.taskType)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.taskForward.taskType,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = i,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.taskForward, "taskType", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.taskForward, "taskType", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.taskForward, "taskType", $$c)
          }
        }
      }
    }), _vm._v("\n                            " + _vm._s(s) + "\n                            ")])])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.taskForward.priority),
      expression: "taskForward.priority"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": ("" + (_vm.$t('priorityLbl')))
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.taskForward, "priority", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.$t('priorityData')), function(s, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v("\n        " + _vm._s(s) + "\n        ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.taskForward.comments),
      expression: "taskForward.comments"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "comments",
      "id": "comments",
      "placeholder": ("" + (_vm.$t('comments')))
    },
    domProps: {
      "value": (_vm.taskForward.comments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.taskForward, "comments", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-success ",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.submit($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('submit')))])]), _vm._v(" "), (_vm.error.length > 0) ? _c('div', {
    staticClass: "alert alert-danger padding5"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5e1fb560!./~/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/TaskForm.vue
// module id = 721
// module chunks = 1